import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import BusinessMpProvider from "@/core/data-provider/data-mp/business/business-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { setServiceInfo } from "@/domains/business/slice";
import toast from "@/domains/toasts/helpers/toast";

export default function useGetServiceInfo() {
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation("business");

  const [isPending, setIsPending] = useState(false);

  const getServiceInfo = useCallback(
    async (businessId: number) => {
      setIsPending(true);
      try {
        const response = await BusinessMpProvider.getServiceState(businessId);

        if (response instanceof RpcMpProviderSuccessResponse) {
          dispatch(setServiceInfo(response.data));
        } else if (i18n.exists(`business:business.errors.${response.error.message}`)) {
          console.error(response.error.message);
          toast.error(t(`business.errors.${response.error.message}`));
        } else {
          console.error(response.error.message);
          toast.error(t("business.toast.serviceGetInfoError"));
        }
      } catch (e) {
        console.error(e);
        toast.error(t("business.toast.serviceGetInfoError"));
      } finally {
        setIsPending(false);
      }
    },
    [dispatch, i18n, t],
  );

  return { isPending, getServiceInfo };
}
